// Video Gallery Modal
// Grab the heights of items and set them to be equal
function setDescHeight() {
    let height = 0;
    const videoGridDescriptions = Array.from(
        document.querySelectorAll(".m-videoGrid__description")
    );

    if (videoGridDescriptions.length > 0) {
        videoGridDescriptions.forEach((videoGridDescription) => {
            if (videoGridDescription.offsetHeight > height) {
                height = videoGridDescription.offsetHeight;
            }
        });

        videoGridDescriptions.forEach((videoGridDescription) => {
            videoGridDescription.style.height = `${height}px`;
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const videoGridVideos = Array.from(
        document.querySelectorAll(".o-videoGrid__video")
    );
    const videoGridVideoCloseButtons = Array.from(
        document.querySelectorAll(".o-videoGrid__close")
    );

    if (videoGridVideos.length > 0) {
        let dialogId = "";
        let videoURL = "";
        videoGridVideos.forEach((videoGridVideo) => {
            videoGridVideo.addEventListener("click", (e) => {
                e.stopPropagation();

                dialogId = "dialog-" + e.currentTarget.dataset.dialog;
                videoURL = document.querySelector(`#${dialogId} iframe`).dataset
                    .src;
                document.querySelector(`#${dialogId} iframe`).src = videoURL;
                document.querySelector(`#${dialogId}`).showModal();
            });
        });

        videoGridVideoCloseButtons.forEach((videoGridVideoCloseButton) => {
            videoGridVideoCloseButton.addEventListener("click", (e) => {
                document.querySelector(`#${dialogId} iframe`).src = videoURL;
                const dialogBox = e.currentTarget.parentElement;
                dialogBox.close();
            });
        });
    }

    // Maintains video description height across the entire grid
    setDescHeight();
    window.addEventListener("resize", () => {
        setDescHeight();
    });
});
